import CardIconAmex from '~/images/icons/credit-card-brands/amex.png';
import CardIconDiners from '~/images/icons/credit-card-brands/diners.png';
import CardIconDiscover from '~/images/icons/credit-card-brands/discover.png';
import CardIconJcb from '~/images/icons/credit-card-brands/jcb.png';
import CardIconMastercard from '~/images/icons/credit-card-brands/mastercard.png';
import CardIconUnionpay from '~/images/icons/credit-card-brands/unionpay.png';
import CardIconVisa from '~/images/icons/credit-card-brands/visa.png';
import cx from 'classnames';
import store from '~/javascripts/store';
import { CardCvcElement } from '@stripe/react-stripe-js';
import { observer, useLocalObservable } from 'mobx-react';

const SavedPaymentMethods = observer(
  ({ cardCvcElementClassOverrides, cardCvcElementStyles }) => {
    const cardIcons = {
      amex: CardIconAmex,
      diners: CardIconDiners,
      discover: CardIconDiscover,
      jcb: CardIconJcb,
      mastercard: CardIconMastercard,
      unionpay: CardIconUnionpay,
      visa: CardIconVisa,
    };

    const localStore = useLocalObservable(() => ({
      isSavedPaymentsDropdownOpen: false,
    }));

    const handleCardCvcElementChange = (event) => {
      store.donateForm.cardCvcElementError = '';

      if (event.error) {
        const error = event.error.message.replace('.', '');
        store.donateForm.cardCvcElementError = error;
      }

      store.donateForm.cardCvcElementCompleted = event.complete;
    };

    const handleSavedPaymentOptionClick = (card) => {
      store.donateForm.selectedStripePaymentMethodCard = card;
      localStore.isSavedPaymentsDropdownOpen = false;
      store.donateForm.cardCvcElementError = '';
    };

    const savedCardsExceptSelectedCard = () => {
      if (!store.donateForm.selectedStripePaymentMethodCard)
        return store.donateForm.stripePaymentMethodCards;

      return store.donateForm.stripePaymentMethodCards.filter(
        (card) =>
          card.paymentMethodId !==
          store.donateForm.selectedStripePaymentMethodCard.paymentMethodId
      );
    };

    const renderAddNewCardOption = () => (
      <>
        <div className='flex items-center rounded-sm mr-1'>
          <span className='bg-cw-white cw-icon-plus flex items-center justify-center' />
        </div>

        <p className='text-cw-navy font-medium'>Add new card</p>
      </>
    );

    return (
      <>
        <div className='saved-payment-options flex-col'>
          <div
            className={cx(
              { expanded: localStore.isSavedPaymentsDropdownOpen },
              'header cursor-pointer w-full pr-1 flex items-center justify-between'
            )}
            onClick={() => {
              localStore.isSavedPaymentsDropdownOpen =
                !localStore.isSavedPaymentsDropdownOpen;
            }}
          >
            <div className='card-option flex items-center'>
              {store.donateForm.selectedStripePaymentMethodCard ? (
                <>
                  <div className='card-brand-icon flex items-center rounded-sm mr-1'>
                    <img
                      src={
                        cardIcons[
                          store.donateForm.selectedStripePaymentMethodCard.brand
                        ]
                      }
                    />
                  </div>
                  <p>
                    Card ending in{' '}
                    {store.donateForm.selectedStripePaymentMethodCard.last4}
                  </p>
                </>
              ) : (
                renderAddNewCardOption()
              )}
            </div>

            <a className='h80 icn text-strong-heading text-cw-navy'>
              <p className='h80 hidden md-inline-block'>Change</p>{' '}
              <span
                className={
                  localStore.isSavedPaymentsDropdownOpen
                    ? 'cw-icon-caret-up'
                    : 'cw-icon-caret-down'
                }
              />
            </a>
          </div>

          <div
            className={cx(
              { expanded: localStore.isSavedPaymentsDropdownOpen },
              'expand bg-grey-5 cursor-pointer overflow-y-auto'
            )}
          >
            <div className='expand-inner'>
              {savedCardsExceptSelectedCard().map((card) => (
                <div
                  className='card-option flex justify-between items-center'
                  key={card.paymentMethodId}
                  onClick={() => handleSavedPaymentOptionClick(card)}
                >
                  <div className='flex items-center'>
                    <div className='card-brand-icon flex items-center rounded-sm mr-1'>
                      <img src={cardIcons[card.brand]} />
                    </div>
                    <p>Card ending in {card.last4}</p>
                  </div>
                  <span className='h70 text-grey-40 cw-icon-ok' />
                </div>
              ))}

              {store.donateForm.selectedStripePaymentMethodCard && (
                <div
                  className='card-option flex justify-between items-center'
                  onClick={() => handleSavedPaymentOptionClick(undefined)}
                >
                  <div className='flex items-center'>
                    {renderAddNewCardOption()}
                  </div>
                  <span className='h70 text-grey-40 cw-icon-ok' />
                </div>
              )}
            </div>
          </div>
        </div>

        {store.donateForm.cvcVerificationRequired && (
          <>
            <div className='flex items-center'>
              <div className='w-1/4'>
                <CardCvcElement
                  className={cx(
                    'rounded card-element-input-padding border border-solid border-grey-40',
                    {
                      error: !!store.donateForm.cardCvcElementError,
                    }
                  )}
                  onChange={handleCardCvcElementChange}
                  options={{
                    classes: cardCvcElementClassOverrides,
                    style: cardCvcElementStyles,
                  }}
                />
              </div>

              <p className='h80 ml-1 text-grey-60 text-left w-3/4'>
                For your security, please re-enter the CVC for your card ending
                in {store.donateForm.selectedStripePaymentMethodCard.last4}.
              </p>
            </div>

            <ul className='parsley-errors-list'>
              <li>{store.donateForm.cardCvcElementError}</li>
            </ul>
          </>
        )}
      </>
    );
  }
);

export default SavedPaymentMethods;
